import { Component, EventEmitter } from '@angular/core';
import { ContainerNumberHelper } from '../../Helper/ContainerNumberHelper';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NameModel } from '../../model/NameModal';
import { CommonModule } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-bulk-upsert-items',
  standalone: true,
  imports: [CommonModule, NgSelectComponent, ReactiveFormsModule],
  templateUrl: './bulk-upsert-items.component.html',
  styleUrl: './bulk-upsert-items.component.scss'
})
export class BulkUpsertItemsComponent {
  containerNumberList: string[] = [];
  addContainerLineItem!: FormGroup;

  containerTypes: NameModel[] = [
    { id: 1, name: "GP" },
    { id: 2, name: "HC" },
    { id: 3, name: "FR" },
    { id: 4, name: "OT" },
    { id: 5, name: "RF" },
  ];

  availableCtrSources: NameModel[] = [
    { id: 1, name: 'Bulk insert' },
    { id: 3, name: 'BACC file' },
  ];

  doorDirections: NameModel[] = [
    { id: 1, name: 'Any' },
    { id: 2, name: 'Front' },
    { id: 3, name: 'Rear' },
    { id: 4, name: 'B2B' },
  ];

  constructor(
    private fb: FormBuilder,
    protected activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.addContainerLineItem = this.fb.group({
      createSource: this.fb.control(this.availableCtrSources[0]),
      ctrCount: this.fb.control(1),
      doorDirection: this.fb.control(this.doorDirections[0]),
      containerType: this.fb.control(null),
      seal: this.fb.control(null),
      storageDays: this.fb.control(0),
      pin: this.fb.control(null),
      SVGFEImageElement: this.fb.control(null),
      dangerousGoods: this.fb.control(false),
      mpi: this.fb.control(false),
      ctrSrc: this.fb.control(null)
    });
  }

  onSave() {
    this.activeModal.close({ formGroup: this.addContainerLineItem, containerNumbers: this.containerNumberList });
  }

  close() {
    this.activeModal.close();
  }

  onPaste(event: ClipboardEvent): void {
    if (event.clipboardData) {
      const clipboardData = event.clipboardData.getData('text/plain');

      if (clipboardData) {
        this.containerNumberList = this.parsePastedData(clipboardData);
      }
    }
  }

  parsePastedData(data: string): string[] {
    const rows = data.split('\n');
    let containerNumbers: string[] = [];

    rows.map(row => {
      let newStringWithUnderscore = row.replace(/[&\/\\#, +()$~%.'":*?<>{}-]/g, '_');

      newStringWithUnderscore.split('_').map(function (item) {
        if (item) {
          containerNumbers.push(item);
        }
      });
    });

    return containerNumbers;
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLTextAreaElement;
    const textContent = inputElement.value;
    this.updateElements(textContent);
  }

  updateElements(textContent: string): void {
    const listOfText = textContent.split(/[\s\n&\/\\#, +()$~%.'":*?<>{}-]+/).filter(element => element.trim() !== '');
    this.containerNumberList = listOfText;
  }

  isValidContainerNumber(containerNumber: string): boolean {
    return ContainerNumberHelper.containerNumberIsValid(containerNumber);
  }
}
